import React, { useState } from 'react'

import FormBlock from 'components/Forms/FormBlock'
import FormModal from 'components/Modal/FormModal/FormModal'
import Toast, { TOAST_TYPE } from 'components/Toast/Toast'
import Input from 'components/Forms/Input/Input'

import { fieldsValidator, getIsNotEmptyStringRule, getIsValueRule, getIsNotIncludeInArray } from 'utils/fieldsValidator'
import { removeKeyFromObject } from 'utils/common'
import Checkbox from '../../../../../../components/Forms/Checkbox/Checkbox'

const EditCurrencyModal = ({ otherCurrencyCodes, payload, onSubmit, onClose }) => {
    const [isConfirm, setIsConfirm] = useState(false)

    const [currency, setCurrency] = useState(payload.currency)
    const [symbol, setSymbol] = useState(payload.symbol)

    const [errors, setErrors] = useState({})

    const handleSubmit = async () => {
        try {
            setErrors({})

            const validator = new fieldsValidator()

            validator.addFields([
                validator.createField('currency', currency, [
                    getIsValueRule(),
                    getIsNotEmptyStringRule(),
                    getIsNotIncludeInArray(otherCurrencyCodes, `Currency "${currency}" already exist`),
                ]),
                validator.createField('symbol', symbol, [getIsValueRule(), getIsNotEmptyStringRule()]),
            ])

            const { isHasErrors, errors } = validator.validate()
            if (isHasErrors) {
                setErrors(errors)
                return
            }

            await onSubmit({ ...payload, currency, symbol })

            return true
        } catch (err) {
            console.error(err)
            Toast(TOAST_TYPE.ERROR)
            throw err
        }
    }

    return (
        <FormModal
            headText="Update currency"
            successText="Currency updated successfully!"
            subHeadText="Make sure the currency is added to Stripe!"
            subHeadTextColor="#FA655C"
            actionText="Update"
            onAction={() => handleSubmit()}
            onClose={() => onClose()}
            isDisabledAction={!isConfirm}
        >
            <FormBlock label="Currency">
                <Input
                    value={currency}
                    error={errors.currency}
                    onChange={value => {
                        setCurrency(value)
                        setErrors(removeKeyFromObject(errors, 'currency'))
                    }}
                />
            </FormBlock>
            <FormBlock label="Symbol">
                <Input
                    value={symbol}
                    error={errors.symbol}
                    onChange={value => {
                        setSymbol(value)
                        setErrors(removeKeyFromObject(errors, 'symbol'))
                    }}
                />
            </FormBlock>
            <FormBlock>
                <Checkbox
                    value={isConfirm}
                    label="I confirm that I am sober and this currency has been added to Stripe"
                    onChange={value => setIsConfirm(value)}
                />
            </FormBlock>
        </FormModal>
    )
}

export default EditCurrencyModal
